// 2. This code loads the IFrame Player API code asynchronously.
var tag = document.createElement('script');

tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

// 3. This function creates an <iframe> (and YouTube player)
//    after the API code downloads.
var player;

function onYouTubeIframeAPIReady() {
  player = new YT.Player('player', {
    height: '100%',
    width: '100%',
    videoId: 'dJb7shacG_o',
    allowfullscreen: false,
    // events: {
    //   'onReady': onPlayerReady,
    //   'onStateChange': onPlayerStateChange
    // },
    playerVars: {
      autoplay: 0, // 在讀取時自動播放影片
      controls: 1, // 在播放器顯示暫停／播放按鈕
      rel: 0, // 表示播放器是否應顯示相關視頻時，初始視頻播放結束。
      // showinfo: 1,        // 隱藏影片標題
      // modestbranding: 1,  // 隱藏YouTube Logo
      loop: 1, // 讓影片循環播放
      // fs: 0,              // 隱藏全螢幕按鈕
      // cc_load_policty: 0, // 隱藏字幕
      // iv_load_policy: 3,  // 隱藏影片註解
      // autohide: 0         // 當播放影片時隱藏影片控制列
    }
  });
}

// 4. The API will call this function when the video player is ready.
// function onPlayerReady(event) {
//   // event.target.playVideo();
//   // player.pauseVideo();
//   // console.log('載入影片');
// }





// 5. The API calls this function when the player's state changes.
//    The function indicates that when playing a video (state=1),
//    the player should play for six seconds and then stop.
var done = false;



// function onPlayerStateChange(event) {
//   // if (event.data == YT.PlayerState.PLAYING && !done) {
//   //   setTimeout(stopVideo, 6000);
//   //   done = true;
//   // }
// }

$(window).scroll(function () {
  if ($(window).width() > 768) {
    if ($(window).scrollTop() > $('.l-section-5').offset().top - 100 && $(window).scrollTop() < $('.l-section-6').offset().top) {
      console.log('播放影片');
      player.playVideo();
    } else {
      console.log('暫停播放影片');
      player.pauseVideo();
    }
  }
});

// function stopVideo() {
//   player.stopVideo();
// }